;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import dayjs from 'dayjs';
import { isValidPhoneNumber } from 'react-phone-number-input';
import validateNationalNumber from './validateNationalNumber';
import validateMail from './validateEmailAddress';

export default function checkInputValidity(input, name) {
  let inputValid = true;
  const { required, value, minLength, type } = input;

  let momentFromInput = null;
  if (type === 'date') momentFromInput = dayjs(value, 'YYYY-MM-DD');

  if (
    (required && value?.length < minLength) ||
    (required && !value) ||
    (type === 'email' && !validateMail(value)) ||
    (type === 'formatted' && !validateNationalNumber(value)) ||
    (type === 'date' && !momentFromInput.isValid()) ||
    // birthDates younger than 16, older 150 not allowed
    (name &&
      momentFromInput &&
      name === 'birthDate' &&
      (dayjs().diff(momentFromInput, 'year') < 16 || dayjs().diff(momentFromInput, 'year') > 150)) ||
    // no special charachters allowed for firstName and lastName
    (name &&
      (name === 'firstName' || name === 'lastName') &&
      // eslint-disable-next-line no-useless-escape
      /[~`!#$%\^&*+=\-\[\]\\';,/{}()|@\\":<>\?]/g.test(value)) ||
    (type === 'tel' && !isValidPhoneNumber(value))
  )
    inputValid = false;

  return inputValid;
}
